const WORKER_URL = "https://opportunity-scanner.ahmed-opportunity-scanner.workers.dev";
const API_BASE = `${WORKER_URL}/api`;

async function fetchApi<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(`${API_BASE}${endpoint}`, {
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    },
    ...options
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: "Request failed" }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }
  
  return response.json();
}

export const api = {
  opportunities: {
    list: (params?: { status?: string; limit?: number; offset?: number }) => 
      fetchApi<{ opportunities: any[] }>("/opportunities?" + new URLSearchParams(params as Record<string, string>)),
    get: (id: string) => fetchApi<any>(`/opportunities/${id}`)
  },
  pitches: {
    list: (params?: { status?: string; limit?: number; offset?: number }) => 
      fetchApi<{ pitches: any[] }>("/pitches?" + new URLSearchParams(params as Record<string, string>)),
    get: (id: string) => fetchApi<any>(`/pitches/${id}`),
    approve: (id: string) => fetchApi<{ success: boolean }>(`/pitches/${id}/approve`, { method: "POST" }),
    reject: (id: string, feedback?: string) => fetchApi<{ success: boolean }>(`/pitches/${id}/reject`, { 
      method: "POST", 
      body: JSON.stringify({ feedback }) 
    })
  },
  companies: {
    list: (params?: { q?: string; limit?: number }) => 
      fetchApi<{ companies: any[] }>("/companies?" + new URLSearchParams(params as Record<string, string>)),
    get: (id: string) => fetchApi<any>(`/companies/${id}`)
  },
  stats: {
    get: () => fetchApi<any>("/stats")
  },
  triggers: {
    fetch: () => fetchApi<{ success: boolean; results: any }>("/trigger/fetch", { method: "POST" }),
    enrich: () => fetchApi<{ success: boolean; enriched: number }>("/trigger/enrich", { method: "POST" }),
    match: () => fetchApi<{ success: boolean; results: any[] }>("/trigger/match", { method: "POST" }),
    pitches: () => fetchApi<{ success: boolean; processed: number }>("/trigger/pitches", { method: "POST" })
  },
  admin: {
    initSkills: () => fetchApi<{ success: boolean; skills_initialized: number }>("/admin/init-skills", { method: "POST" })
  }
};